module.exports = __webpack_public_path__ + "47fc1add/img/chevron-down-icon.5542f65c.svg";